// Small site-wide reminder of the subjects every page is using (the confirmed Pick), with a link to change them.
import React from "react";
import { Link } from "react-router-dom";
import { BookOpen } from "lucide-react";
import { useJourney } from "@/context/JourneyContext";

export function SubjectsBadge({ className = "" }) {
  const { profile } = useJourney();
  const subjects = (profile?.what?.subjects_confirmed || []).map((s) => (typeof s === "string" ? s : s?.label || s?.slug)).filter(Boolean);
  if (!subjects.length) return null;
  return (
    <div className={`flex print:hidden ${className}`}>
      <Link to="/beta/course-fit" data-testid="subjects-badge"
        title="These are the subjects the site uses for cities, courses and chances. Change them in Fast Fit."
        className="inline-flex max-w-full items-start gap-2 rounded-2xl border border-[#7C3AED]/40 bg-[#F5F0FF] px-3 py-1 text-xs text-slate-800 transition-colors hover:border-[#7C3AED] hover:bg-[#EDE4FF]">
        <BookOpen className="mt-0.5 h-3.5 w-3.5 shrink-0 text-[#7C3AED]" aria-hidden="true" />
        <span>
          Using: <b className="font-semibold" data-testid="subjects-badge-list">{subjects.join(", ")}</b>{" "}
          <span className="whitespace-nowrap font-medium text-[#7C3AED] underline-offset-2 hover:underline" data-testid="subjects-badge-change">· Change</span>
        </span>
      </Link>
    </div>
  );
}
